<template>
  <div class="w-full flex h-full">

    <div
      class="bg-app-gray px-5 py-10 lg:h-full lg:overflow-y-auto w-full lg:w-[35%] z-10 shadow-lg"
    >
      <slot name="secondary-content"></slot>
    </div>
    <div class="lg:h-full lg:overflow-y-auto px-7 py-5 bg-white w-full lg:w-[65%]">
      <slot name="main-content"></slot>
    </div>

  </div>
</template>

<script lang="ts">
export default {
  name: 'HomeContentLayout'
};
</script>
